import Image from 'next/image';

import { castDetails } from './CastDetails';
import CastModal from './CastModal';

const Component: React.FC = () => {
  return (
    <div className="my-5 grid w-full grid-cols-2 grid-rows-4 gap-5 md:grid-cols-4 md:grid-rows-2">
      {castDetails.map(cast => (
        <div key={cast.name}>
          <div>
            <div className="relative">
              <Image
                src={cast.image}
                alt=""
                className="-z-10 block w-full rounded md:w-[calc(100%-15px)]"
              />
              <div className="flex justify-center md:justify-end">
                <div className="absolute z-10 -mt-7 bg-orange-600 p-2 text-[15px] font-bold text-white">
                  {cast.name}
                  {cast.title}
                </div>
              </div>
            </div>
            <div className="mb-2 mt-6 text-xs leading-relaxed">
              {cast.description1}
              <br />
              {cast.description2}
            </div>
          </div>
          <CastModal cast={cast} />
        </div>
      ))}
    </div>
  );
};

export default Component;
